import type { UseFormReturn } from 'react-hook-form';

import { ORDER_SERVICE_FORM_INPUT_KEYS, type OrderServiceFormInput } from 'components/context/OrderServiceFormContext/_constants/inputKeys';

export const getDropdownsValues = (form: UseFormReturn<OrderServiceFormInput, any>) => ({
  serviceTypeValue: form.watch(ORDER_SERVICE_FORM_INPUT_KEYS.serviceType as 'serviceType'),
  serviceSubtypeValues: form.watch(ORDER_SERVICE_FORM_INPUT_KEYS.serviceSubtype as 'serviceSubtype'),
  servicesFromSubtypesValue: form.watch(ORDER_SERVICE_FORM_INPUT_KEYS.serviceFromSubtype as 'serviceFromSubtype'),
});
